import PropTypes from 'prop-types';

export default {
  createUserPassword: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string
    })
  })
};
